/* ============================================================
   หัวเอกสารส่วนข้อมูลสินค้า ใช้ร่วมกันทุกฟอร์มของ Production Order
   (ห้องสารส่วนผสม / ห้องตัดแต่ง / ห้องเคี่ยว)

   Job order ...................................... วันที่ ...
   FG code ......   FG name ...................   รหัส ......
   PK code ......   PK name ...................
============================================================ */
import "./pd-doc-meta.css";

export default function PdDocMeta({ form = {}, date }) {
  return (
    <div className="pd-meta">
      <div className="pd-meta-row">
        <span className="pd-meta-k">Job order</span>
        <span className="pd-meta-v pd-meta-wide">{form.jocode || ""}</span>
        <span className="pd-meta-k">วันที่</span>
        <span className="pd-meta-v pd-meta-date">{date || ""}</span>
      </div>
      <div className="pd-meta-row">
        <span className="pd-meta-k">FG code</span>
        <span className="pd-meta-v pd-meta-code">{form.fg_code || ""}</span>
        <span className="pd-meta-k">FG name</span>
        <span className="pd-meta-v pd-meta-name">{form.fg_name || form.pg_name || ""}</span>
        <span className="pd-meta-k">รหัส</span>
        <span className="pd-meta-v pd-meta-date">{form.product_no || ""}</span>
      </div>
      <div className="pd-meta-row">
        <span className="pd-meta-k">PK code</span>
        <span className="pd-meta-v pd-meta-code">{form.pk_code || ""}</span>
        <span className="pd-meta-k">PK name</span>
        <span className="pd-meta-v pd-meta-name">{form.pk_name || ""}</span>
      </div>
    </div>
  );
}
